interface UseShortsVideoStateOptions {
	initialMuted: MaybeRef<boolean>;
	isExternallyPaused: MaybeRef<boolean>;
	onFirstVideoLoaded?: () => void;
}

export function useShortsVideoState(options: UseShortsVideoStateOptions) {
	const hasCurrentVideoLoaded = ref(false);
	const hasCurrentVideoBuffered = ref(false);
	const hasCurrentVideoPlaying = ref(false);
	const hasEmittedFirstVideoLoaded = ref(false);
	const isGlobalMuted = ref(toValue(options.initialMuted));
	const isTapPaused = ref(false);

	const isVideoEffectivelyPaused = computed(
		() => toValue(options.isExternallyPaused) || isTapPaused.value
	);

	function resetCurrentVideoState(resetFirstVideoLoaded = false) {
		hasCurrentVideoLoaded.value = false;
		hasCurrentVideoBuffered.value = false;
		hasCurrentVideoPlaying.value = false;
		isTapPaused.value = false;

		if (resetFirstVideoLoaded) {
			hasEmittedFirstVideoLoaded.value = false;
		}
	}

	function toggleGlobalMute() {
		isGlobalMuted.value = !isGlobalMuted.value;
	}

	function setGlobalMuted(isMuted: boolean) {
		isGlobalMuted.value = isMuted;
	}

	function handleVideoTap() {
		isTapPaused.value = !isTapPaused.value;
	}

	function handleVideoLoaded(index: number, currentIndex: number) {
		if (index !== currentIndex || hasCurrentVideoLoaded.value) return;

		hasCurrentVideoLoaded.value = true;

		if (!hasEmittedFirstVideoLoaded.value) {
			hasEmittedFirstVideoLoaded.value = true;
			options.onFirstVideoLoaded?.();
		}
	}

	function handleVideoPlaying(index: number, currentIndex: number) {
		if (index !== currentIndex || hasCurrentVideoPlaying.value) return;
		hasCurrentVideoPlaying.value = true;
	}

	function handleVideoBuffered(index: number, currentIndex: number) {
		if (index !== currentIndex || hasCurrentVideoBuffered.value) return;
		hasCurrentVideoBuffered.value = true;
	}

	return {
		hasCurrentVideoLoaded,
		hasCurrentVideoBuffered,
		hasEmittedFirstVideoLoaded,
		isGlobalMuted,
		isTapPaused,
		isVideoEffectivelyPaused,
		resetCurrentVideoState,
		toggleGlobalMute,
		setGlobalMuted,
		handleVideoTap,
		handleVideoLoaded,
		handleVideoPlaying,
		handleVideoBuffered
	};
}
